import React from 'react';
import { translate } from '../Services/translation';
import _ from 'lodash';
import { getData } from '../Services/LocalStorage.service';

const CompareButton = ({ articleNumber, amountOfProducts, count }) => {
    const comparisonLimit = 6;
    const comparedArticleNumbers = getStoredArticleNumbers();
    const alreadyComparing = _.some(comparedArticleNumbers, a => a === articleNumber);

    function onClick(articleNumber) {
        let dataToStore = [];

        if (_.some(comparedArticleNumbers, a => a === articleNumber)) {
            dataToStore = _.without(comparedArticleNumbers, articleNumber);
        } else {
            dataToStore = [...comparedArticleNumbers, articleNumber];
        }

        localStorage.setItem('products', JSON.stringify(dataToStore));

        amountOfProducts(dataToStore.length);
    }

    function getStoredArticleNumbers() {
        return getData('products', []);
    }


    return (
        <span
            className={count === comparisonLimit && !alreadyComparing ? 'hidden' : ''}
            onClick={() => onClick(articleNumber)}
        >
            {alreadyComparing ? (
                <img src="/ui/images/minus.svg" alt="Compare function" />
            ) : (
                <img src="/ui/images/switch.svg" alt="Compare function" />
            )}
            <span className="compare-text">{translate('product.compare')}</span>
        </span>
    );
};

export default CompareButton;
